import { useState, useEffect, useContext } from "react";
import { FiMail, FiLock } from "react-icons/fi";
import { SendOtp } from "../../services/auth/SendOtp";
import { DContext } from "../../context/Datacontext";
import { useNavigate } from "react-router-dom";
import Logo from '../../assets/WhatsApp Image 2025-12-17 at 3.56.49 PM.jpeg'
import Loading from "../../components/Loading";

export const ForgotPassword = () => {
    const { BeURL, loading,setLoading } = useContext(DContext);
    const [step, setStep] = useState(1);

    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [message, setMessage] = useState("");

    const [timer, setTimer] = useState(30);
    const [canResend, setCanResend] = useState(false);

    const navigate = useNavigate();

    // OTP timer
    useEffect(() => {
        let interval;

        if (step === 2 && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }

        if (timer === 0) {
            setCanResend(true);
        }

        return () => clearInterval(interval);
    }, [timer, step]);

    // Send OTP
    const handleSendOtp = async (e) => {
        e.preventDefault();

        if (!email) {
            setMessage("Please enter email");
            return;
        }

        setLoading(true);

        const res = await SendOtp({
            BeURL,
            email,
            purpose: "forgot-password",
        });

        setLoading(false);

        if (res.success) {
            setStep(2);
            setTimer(30);
            setCanResend(false);
            setMessage("OTP sent to your email");
        } else {
            setMessage(res.message);
        }
    };

    // Resend OTP
    const handleResend = async () => {
        setTimer(30);
        setCanResend(false);

        await SendOtp({
            BeURL,
            email,
            purpose: "forgot-password",
        });
    };

    // Reset Password
    const handleResetPassword = async (e) => {
        e.preventDefault();

        if (!otp) return setMessage("Enter OTP");
        if (password !== confirmPassword)
            return setMessage("Passwords do not match");

        setLoading(true);

        try {
            const res = await fetch(`${BeURL}/reset-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials : 'include',
                body: JSON.stringify({
                    email,
                    otp,
                    password,
                }),
            });

            const data = await res.json();

            setLoading(false);

            if (!res.ok) {
                setMessage(data.message);
                return;
            }

            setMessage("Password reset successful");
            setStep(3);
            navigate("/login");
        } catch (err) {
            setLoading(false);
            setMessage("Server error");
        }
    };

    return (
        <div className="flex items-center justify-center">
            <div className="w-full max-w-md p-8 space-y-6">
                <div className="flex flex-col items-center">
                    <img src={Logo} alt="logo" className="mb-6 h-auto w-32" />
                </div>
                <h2 className="text-2xl font-semibold mb-2">Welcome Back to SAN LMS</h2>
                <p>
                    No worries! Enter your registered email to receive an OTP and continue your learning journey with SAN LMS.
                </p>
                {/* STEP 1 EMAIL */}
                {step === 1 && (
                    <form onSubmit={handleSendOtp} className="mt-6 space-y-4">

                        <div>
                            <label className="text-sm font-medium text-gray-700">
                                Email Address
                            </label>

                            <div className="relative mt-1">
                                <FiMail className="absolute left-3 top-3 text-gray-400" />

                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full border rounded-lg pl-10 pr-3 py-2 text-sm focus:ring-2 focus:ring-primary-500"
                                />
                            </div>
                        </div>

                        <button
                            onSubmit={handleSendOtp}
                            type="submit"
                            disabled={loading}
                            className="w-full py-3 flex justify-center rounded-lg bg-primary-600 text-white font-medium hover:bg-primary-700"
                        >
                            {loading ? <Loading size={30} className="text-white" /> : "Sent OTP"}
                        </button>

                        <button
                            type="button"
                            onClick={() => (navigate('/login'))}
                            className="w-full py-2 rounded-lg bg-white border border-primary-600 text-primary-600 font-medium hover:bg-primary-100"
                        >
                            Back to Login
                        </button>
                    </form>
                )}

                {/* STEP 2 OTP + PASSWORD */}
                {step === 2 && (
                    <form className="mt-6 space-y-4">

                        {/* OTP */}
                        <div>
                            <label className="text-sm font-medium text-gray-700">
                                Enter OTP
                            </label>

                            <input
                                type="text"
                                maxLength={6}
                                placeholder="Enter OTP"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                className="w-full border rounded-lg px-3 py-2 mt-1 text-sm"
                            />

                            {!canResend ? (
                                <p className="text-xs text-gray-500 mt-1">
                                    Resend OTP in {timer}s
                                </p>
                            ) : (
                                <button
                                    type="button"
                                    onClick={handleResend}
                                    className="text-xs text-primary-600 mt-1"
                                >
                                    Resend OTP
                                </button>
                            )}
                        </div>

                        {/* Password */}
                        <div>
                            <label className="text-sm font-medium text-gray-700">
                                New Password
                            </label>

                            <div className="relative mt-1">
                                <FiLock className="absolute left-3 top-3 text-gray-400" />

                                <input
                                    type="password"
                                    placeholder="Enter new password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="w-full border rounded-lg pl-10 pr-3 py-2 text-sm"
                                />
                            </div>
                        </div>

                        {/* Confirm Password */}
                        <div>
                            <label className="text-sm font-medium text-gray-700">
                                Confirm Password
                            </label>

                            <input
                                type="password"
                                placeholder="Confirm password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="w-full border rounded-lg px-3 py-2 mt-1 text-sm"
                            />
                        </div>
                        <button
                            onClick={handleResetPassword}
                            type="submit"
                            disabled={loading}
                            className="w-full flex justify-center py-2 rounded-lg bg-primary-600 text-white font-semibold"
                        >
                            {loading ? <Loading size={30} className="text-white" /> : "Reset Password"}                            
                        </button>
                    </form>
                )}

                {/* Success */}
                {step === 3 && (
                    <div className="mt-6 text-center text-green-600 font-medium">
                        Password reset successfully. You can now login.
                    </div>
                )}

                {/* Message */}
                {message && (
                    <div className="text-sm text-center mt-4 text-gray-600">
                        {message}
                    </div>
                )}
            </div>
        </div>
    );
};